import { ReactElement, useState } from "react";
import { Field } from "react-final-form";
import ButtonContainer from "@components/ButtonContainer";
import FormatTitleIcon from "mdi-react/FormatTitleIcon";
import ImageFilterDramaIcon from "mdi-react/ImageFilterDramaIcon";
import LinkVariantIcon from "mdi-react/LinkVariantIcon";
import FormTextField from "@components/Shared/FormTextField";
import renderSelectField from "@easydev/form/Select";
import { useTranslation } from "react-i18next";
import useStates from "@mappers/Shared/getState.mapper";
import IFormProps from "@interfaces/Shared/formProps";

const CreateForm = ({ handleSubmit }: IFormProps): ReactElement => {
  const { t } = useTranslation(["core", "whaleshark"]);
  const { GetState, GetStates } = useStates();
  const [status] = useState(GetState(true));

  return (
    <form className="form form--horizontal" onSubmit={handleSubmit}>
      <div className="form__form-group">
        <span className="form__form-group-label">{t("core:common.title")}</span>
        <div className="form__form-group-field">
          <div className="form__form-group-icon">
            <FormatTitleIcon />
          </div>
          <Field
            name="title"
            component={FormTextField}
            type="text"
            placeholder={t("core:common.title")}
            isAboveError
          />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">
          {t("core:common.url_image")}
        </span>
        <div className="form__form-group-field">
          <div className="form__form-group-icon">
            <ImageFilterDramaIcon />
          </div>
          <Field
            name="imageUrl"
            component={FormTextField}
            type="text"
            placeholder="https://myimage..."
            isAboveError
          />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">
          {t("core:common.opensea_url")}
        </span>
        <div className="form__form-group-field">
          <div className="form__form-group-icon">
            <LinkVariantIcon />
          </div>
          <Field
            name="openSeaUrl"
            component={FormTextField}
            type="text"
            placeholder="https://opensea.io..."
            isAboveError
          />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">{t("core:common.state")}</span>
        <div className="form__form-group-field">
          <Field
            name="state"
            component={renderSelectField}
            type="text"
            placeholder={`${t("core:common.select_placeholder")} ${t(
              "core:common.state"
            )}`}
            options={GetStates()}
            initialValue={status}
          />
        </div>
      </div>

      <ButtonContainer />
    </form>
  );
};

export default CreateForm;
